import React, {useState, useEffect} from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { H5, Btn } from '../../../AbstractElements';
import { Create, UpcomingScheduleTitle } from '../../../Constant';
import { ScheduleListData } from '../../../Data/OnlineCourse';
import ScheduleListBox from './ScheduleListBox';
import { UpcomingAppointmentList } from '../../../apiController';
const userdata = JSON.parse(localStorage.getItem("userdata"));
  console.log(userdata)
 export const userId = userdata?.user?.id


const UpcomingSchedule = ({roleId}) => {

  const [large, setLarge] = useState(false)
  const [bookingId, setId] = useState('')
  const [appoitmentList, setAppointmentList] = useState([])

  

  const LargeModaltoggle = (id) => {
    setLarge(!large)
    setId(id)
  }

  useEffect(()=>{
    const currentDate = new Date();
  const seventhDate = new Date();

  seventhDate.setDate(currentDate.getDate() + 7);


  if (seventhDate.getMonth() !== currentDate.getMonth()) {
    seventhDate.setMonth(currentDate.getMonth() + 1);
    // seventhDate.setDate(7); // Set the day to the 7th of the next month
  }


// Get the year, month, and day
const year = currentDate.getFullYear();
const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
const day = String(currentDate.getDate()).padStart(2, '0');
const daySeven = String(seventhDate.getDate()).padStart(2, '0');

const seventhMonth = String(seventhDate.getMonth() + 1).padStart(2, '0');

// Format the date as yyyy-mm-dd
const formattedDate = `${year}-${month}-${day}`;
// const toformattedDate = `${year}-${month}-${daySeven}`;
const formattedSeventhDate = `${year}-${seventhMonth}-${daySeven}`;

console.log(formattedDate)
const appointDate = {
// "from": "2024-03-14",
// "to": '2024-03-14'
"from": formattedDate,
"to": formattedSeventhDate
}
// console.log(appointDate)
upcomingAppointmentList(appointDate)
  },[])


  const upcomingAppointmentList = async (date) => {
    const response = await UpcomingAppointmentList(date)
    if(response.status === true){
      const appointmentData = response.data
      console.log(appointmentData)
      console.log(userId)

      let filteredAppointments;

      if (roleId === '4') {
        // const mapID = response['data'].map((id) => id.id)
        filteredAppointments = response['data'].filter((appointment) => appointment.patient_id === userId
        );
      } else if (roleId === '1' || roleId === '2' || roleId === '3' || roleId === '5') {
        filteredAppointments = response['data']
      }

      setAppointmentList(filteredAppointments)
    }
  }

//  const ScheduleListData = appoitmentList?.map((row, ind)=>
//     ({
//       title: `${row.patient_first_name} ${row.patient_sur_name}`,
//       image: '4.jpg',
//       icon: 'bag',
//       icon2: 'clock',
//       date:  row.appointment_date,
//       date2: row.appointments.map((time)=> time.appointment_time).join(','),
//       color: ind % 2 === 0?'primary': 'warning',
//     }))
const ScheduleListData = appoitmentList?.length > 0
  ? appoitmentList.map((row, ind) => ({
      title: `${row.patient_first_name} ${row.patient_sur_name}`,
      image: '4.jpg',
      icon: 'bag',
      icon2: 'clock',
      date: row.appointment_date,
      date2: row.appointments?.map((time) => time.appointment_time).join(',') || 'No data available', // Handle undefined or empty array
      color: ind % 2 === 0 ? 'primary' : 'warning',
    }))
  : [{ title: 'No data available', image: '4.jpg', icon: 'bag', icon2: 'clock', date: '', date2: '', color: 'danger' }];

    // {
    //   title: 'UI/UX Design',
    //   image: '2.jpg',
    //   icon: 'bag',
    //   icon2: 'clock',
    //   date: 'Febuary 10, 2022',
    //   date2: '11.00 - 1.00 PM',
    //   color: 'warning',
    // },
  


  return (
    <Card className='schedule-card'>
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <H5 attrH5={{ className: 'm-0' }}>{UpcomingScheduleTitle}</H5>
          {/* <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: ()=>LargeModaltoggle("") }}>Book an Appointment</Btn> */}
          {/* <div className='card-header-right-icon'>
            <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary' }}>+ {Create}</Btn>
          </div> */}
        </div> 
      </CardHeader>
      <CardBody className='pt-0'>
        <ScheduleListBox data={ScheduleListData} isOpenFun={LargeModaltoggle} isOPen={large} sch={bookingId} />
      </CardBody>
    </Card>
  );
};

export default UpcomingSchedule;
